<template>
  <div class="AddClock">
    <AppHeader v-if="isAdd" :content="isAddContent"></AppHeader>
    <AppHeader v-else :content="isEditContent"></AppHeader>
    <AppBox class="appBox">
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input style="width: 30%" v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item
          label="内容音频"
          v-loading="loading"
          element-loading-text="音频正在生成中，请勿操作..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
        >
          <quill-editor
            ref="quillEditor"
            :class="warning ? 'warningEditor' : 'defaultEditor'"
            :options="editorOptions"
            v-model="formData.description"
            @change="handleChange"
          ></quill-editor>
          <div v-if="warning" class="warningTxt">转音频文字不得超过300字</div>
          <div class="toolsBox">
            <!--            左边部分-->
            <div>
              <!--              播放速度-->
              <div>
                <span>播放速度： </span>
                <el-radio-group v-model="formData.speechRate">
                  <el-radio
                    v-for="item in rateArr"
                    :key="item.value"
                    :label="item.value"
                    >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </div>
              <!--              音频组件-->
              <div class="audioBox" v-if="formData.materialUrl">
                <div>
                  <audio
                    :src="formData.materialUrl"
                    :loop="false"
                    controls
                    preload="auto"
                    controlsList="nodownload noplaybackrate"
                    ref="audioRef"
                  ></audio>
                </div>
                <div style="margin-left: 10px">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleDeleteAudio"
                    >清除音频
                  </el-button>
                </div>
              </div>
            </div>
            <!--            右边按钮-->
            <div>
              <el-button
                size="mini"
                type="primary"
                @click="handlePolyPhoneModal"
                >多音字
              </el-button>
              <el-button size="mini" type="primary" @click="handleCreatAudio"
                >生成音频
              </el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="内容概述" prop="displayDescription">
          <el-input
            type="textarea"
            placeholder="字数不超过160字"
            style="width: 80%"
            v-model="formData.displayDescription"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button
          style="width: 200px"
          type="primary"
          :disabled="loading || warning"
          @click="handleConfirm"
          >确认
        </el-button>
      </div>
      <CorrectPolyPhoneModal
        @refreshInputVal="refreshInputVal"
        :inputValArr="inputValArr"
      ></CorrectPolyPhoneModal>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import { clockMixins } from "@/pages/DailyClock/clockMixins";
import { quillEditor } from "vue-quill-editor";
import CorrectPolyPhoneModal from "@/pages/DailyClock/CorrectPolyPhoneModal.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "AddClock",
  components: { CorrectPolyPhoneModal, AppBox, AppHeader, quillEditor },
  mixins: [clockMixins],
  data() {
    return {
      loading: false,
      isAdd: true,
      isAddContent: "每日打卡 | 新增打卡",
      isEditContent: "每日打卡 | 编辑打卡",
      editorOptions: {
        placeholder:
          "请输入你的内容，选择要展示的性别属性，点击生成音频后方可试听",
      },
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
      inputValArr: [],
      textLength: null,
      warning: false,
    };
  },
  computed: {
    ...mapState("courseCenter", ["audioDetail"]),
  },
  watch: {
    textLength: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.warning = newValue > 300;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    if (this.$route.params.type === "add") {
      this.clearForm();
      this.isAdd = true;
    }
    if (this.$route.params.type === "edit") {
      this.clearForm();
      let clockDetail = JSON.parse(localStorage.getItem("clockDetail"));
      Object.keys(this.formData).map((key) => {
        this.formData[key] = clockDetail[key];
      });
      this.isAdd = false;
      this.disabledEdit();
      this.blurEditor();
      clockDetail = null;
    }
  },
  methods: {
    ...mapMutations("polyPhone", ["setData"]),
    ...mapActions("courseCenter", ["getAudioUrl"]),
    // 内容输入框change事件
    handleChange() {
      this.inputValArr = this.convertToObjects(this.formData.description);
      this.textLength = this.inputValArr.length;
      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    // 清除音频
    handleDeleteAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.formData.description = "";
          this.formData.audioSsmlText = "";
          this.formData.materialUrl = "";
          this.formData.material = "";
          this.formData.speechRate = 1.0;
        })
        .catch(() => {});
    },
    // 生成音频
    async handleCreatAudio() {
      // 生成拼音汉字对象数组
      this.inputValArr = this.convertToObjects(this.formData.description);
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.loading = true;
      // 生成富文本样式
      const inputText = this.creatQuillText(this.inputValArr);
      // 回显到input输入框
      this.refreshInputVal(inputText);
      //   生成ssml文本
      this.formData.audioSsmlText = this.creatSsmlText(this.inputValArr);
      // 调接口生成音频
      try {
        await this.getAudioUrl({
          text: this.formData.audioSsmlText,
          speechRate: this.formData.speechRate,
          voice: "stanley",
        });
        // 媒体名称
        this.formData.material = this.audioDetail.filename;
        // 媒体url
        this.formData.materialUrl = this.audioDetail.url;
      } finally {
        this.loading = false;
      }
    },
    // 打开多音字弹窗
    handlePolyPhoneModal() {
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.inputValArr = this.convertToObjects(this.formData.description);
      this.setData({ key: "polyPhoneModalVisible", value: true });
    },
    // 选择多音字发音弹框确定按钮传过来的富文本编辑器回显inputVal
    refreshInputVal(audioText) {
      this.formData.description = audioText;
      this.$nextTick(() => {
        this.disabledEdit();
        this.blurEditor();
      });
    },
    // 解析为富文本
    creatQuillText(val) {
      return val
        .map((item, index) => {
          if (item.pinyin !== "") {
            if (index % 2 === 0) {
              return `<b style='color: #10689c;'> [${item.pinyin}]${item.cha} </b>`;
            } else {
              return `<b style='color: #10689c;background: transparent;'> [${item.pinyin}]${item.cha} </b>`;
            }
          } else {
            if (item.cha === " ") {
              return "&nbsp;";
            } else {
              return item.cha;
            }
          }
        })
        .join("");
    },
    // 解析为ssml文本，生成音频
    creatSsmlText(val) {
      const ssmlText = val
        .map((item) => {
          if (item.pinyin !== "") {
            return `<phoneme alphabet='py' ph='${item.pinyin}'>${item.cha}</phoneme>`;
          } else {
            return item.cha;
          }
        })
        .join("");
      return "<speak>" + ssmlText + "</speak>";
    },
    // 返回纯文本数组
    convertToObjects(val) {
      const objects = [];
      if (!val) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = val.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;

      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /\{\{\{(.+?)\}\}\}/g;
          const match = item.replace(regex, "$1");
          if (match && match.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({ cha: cha, pinyin: pinyin });
          }
        } else {
          objects.push({ cha: item, pinyin: "" });
        }
      }
      return objects;
    },
    // 多音字不可编辑部分
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          strong.setAttribute("contenteditable", "false");
        });
      });
    },
    //   输入框失去焦点
    blurEditor() {
      this.$nextTick(() => {
        const editor = this.$refs.quillEditor.quill;
        const length = editor.getLength();
        editor.setSelection(length, length);
        editor.blur();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AddClock {
  .appBox {
    width: 100%;
    min-height: calc(100vh - 155px);

    ::v-deep .ql-toolbar.ql-snow {
      display: none;
    }

    ::v-deep .ql-container.ql-snow {
      border: none;
    }

    ::v-deep .ql-editor {
      width: 100%;
      border: none;
      border-radius: 4px;
      height: 150px !important;
      background: #ffffff;
    }

    ::v-deep .defaultEditor {
      width: 80%;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
    }

    ::v-deep .warningEditor {
      width: 80%;
      border-radius: 4px;
      border: 1px solid #f56c6c;
    }

    .warningTxt {
      color: #f56c6c;
      font-size: 12px;
    }

    ::v-deep .ql-editor.ql-blank::before {
      color: #c0c4cc;
      content: attr(data-placeholder);
      font-style: normal;
      font-size: 12px;
      left: 15px;
      pointer-events: none;
      position: absolute;
      right: 15px;
    }

    .toolsBox {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 80%;

      ::v-deep audio {
        margin-top: 10px;
        height: 35px;
        width: 270px;
      }

      .audioBox {
        margin-top: 10px;
        line-height: 35px;
        height: 35px;
        display: flex;
        align-items: center;
      }
    }

    ::v-deep .el-textarea__inner {
      min-height: 120px !important;
    }

    .footer {
      margin-top: 100px;
      text-align: center;
    }
  }
}
</style>
